<!--
 * @Date: 2022-07-12 15:03:12
 * @LastEditTime: 2022-07-19 18:36:50
 * @FilePath: /vue-medweb/packages/vue-m-vaccine-prefecture/src/views/VaccineList/components/Radio.vue
 * @Description: 子类单选组件
-->
<template>
  <div class="radio-list-wrap">
    <div
      v-for="(item, index) in chooseList"
      :key="index"
      :class="['radio-btn', { cur: value === item.type_key }]"
      @click="changeValue(item.type_key)"
    >
      {{ item.type_name }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'Radio',
  props: {
    chooseList: {
      type: Array,
      default: () => [],
    },
    value: {
      type: [String, Number],
      default: '',
    },
  },
  methods: {
    changeValue(value) {
      const choosedValue = value;
      this.$emit('input', choosedValue);
      this.$emit('select', { typeName: choosedValue });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@@/styles/mixin.scss';
.radio-list-wrap {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: rem(-10);
  padding: 0 rem(15);
  background: #fff;
  .radio-btn {
    margin: 0 rem(10) rem(10) 0;
    padding: rem(7) rem(15);
    color: #666;
    font-size: rem(13);
    line-height: rem(15);
    background: #f7f7f7;
    border-radius: rem(14.5);
    @include border-1px(transparent, 29);
  }
  .cur {
    color: #39d167;
    background: rgba(57, 209, 103, 0.1);
    border-radius: rem(14.5);
    @include border-1px(#39d167, 29);
  }
}
</style>
